export default "__VITE_ASSET__D$s5nm$k__"